import { getTeamData, getTeamStatistics } from 'store/actions/teamData';

const teamAdminPage = '/team-admin';
import * as Elements from './elements';

const teamAdminItems = [
    {
        title: 'Members',
        path: `${teamAdminPage}/members`,
        element: <Elements.Members />,
        action: getTeamData,
    },
    {
        title: 'Settings',
        path: `${teamAdminPage}/settings`,
        element: <Elements.Settings />,
        action: getTeamData,
    },
    {
        title: 'Analytics',
        path: `${teamAdminPage}/analytics`,
        element: <Elements.Analytics />,
        action: getTeamStatistics,
    },
];

export { teamAdminItems };
